<template>
  <div id="ua-container">
    <div class="header">
      <a-button type="primary" class="orange-btn" @click="toReturn">
        <a-icon type="rollback" />
        返回列表
      </a-button>
      <div class="flex alignItemsCenter">
        <img class="cover" :src="value.url" alt="无法加载">

        <div class="flex-1">
          <div class="title mb-3" v-if="value.name">
            {{ value.name }}
          </div>

          <div class="text mb-3">
            版本：{{ value.standardName ? value.standardName : "-" }}
          </div>

          <div class="text mb-3">
            年级：{{ value.gradeName ? value.gradeName : "-" }}
          </div>

          <div class="text mb-3">
            科目：{{ value.subjectName ? value.subjectName : "-" }}
          </div>

          <div class="text">
            创建时间：{{ value.createTime ? value.createTime : "-" }}
          </div>
        </div>
      </div>
    </div>
    <a-card class="ui-card card-box2">
      <a-spin :spinning="loading">
        <div class="pagination-box">
          <div class="left-title"><a-icon type="customer-service" /> 听力</div>

          <div>
            <!--
            <a-button class="btn" type="primary" @click="handleDownAudio" v-if="value.subject === 'ENGLISH'" style="margin-right:10px">
              下载音频
            </a-button>
            -->

            <a
              v-if="value.subject === 'ENGLISH'"
              class="btn ant-btn ant-btn-primary"
              style="margin-right: 10px;"
              :href="value | genDownloadUrl('听力')"
            >下载音频</a>

            <a-button class="btn" type="primary" @click="openListen" v-if="value.subject === 'ENGLISH'">
              <div>
                听力材料
              </div>
            </a-button>
          </div>
        </div>
        <div class="player-box" v-if="audioList && audioList.length > 0">
          <audio-player ref="audioPlayer" :playlist="audioList" @ended="handPause" />
        </div>
        <div class="no-data" v-else>
          <a-empty description="暂无听力材料" />
        </div>
        <!-- <div class="titles" v-if="audio?.title">{{ audio.title }}</div>
        <div v-if="audio?.audioMaterial">
          <div v-html="audio.audioMaterial"></div>
          <a-divider style="font-size:13px;color:#999">没有更多了~</a-divider>
        </div>
        <div v-else class="no-data">
          <a-empty description="暂无数据" />
        </div> -->
      </a-spin>
    </a-card>

    <template>
      <a-drawer
        title="查看听力"
        placement="right"
        :closable="true"
        width="99vw"
        :visible="listenVisible"
        @close="listenClose"
      >
        <a-spin :spinning="aloading">
          <div class="titles" v-if="audio?.title">{{ audio.title }}</div>
          <div v-if="audio?.audioMaterial">
            <div v-html="audio.audioMaterial"></div>
            <a-divider style="font-size:13px;color:#999">没有更多了~</a-divider>
          </div>
          <div v-else class="no-data">
            <a-empty description="暂无数据" />
          </div>
        </a-spin>
      </a-drawer>
    </template>
  </div>
</template>

<script>

import audioPlayer from '@/components/player/index.vue'
import { getLessonAduioList } from '@/api/material.js'
import { genDownloadUrl } from '../utils.js'

export default {
  props: {
    value: {
      type: Object,
      default: () => {},
    }
  },
  components: {
    audioPlayer
  },
  data() {
    return {
      // 加载进度
      loading: false,
      aloading: false,
      listenVisible: false,
      audioList: [],
      isShowVoice: false,
      audio: null
    }
  },
  mounted() {
    if (this.value) {
      this.getLessonAduioList(this.value.id)
    }
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.toBack, false)
    }
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.toBack, false)
  },
  filters: {
    genDownloadUrl
  },
  methods: {
    // 返回
    toReturn() {
      this.$emit("change")
      this.isError = false
    },
    // 监听浏览器返回或手机物理按键返回
    toBack () {
      this.toReturn()
      console.log('返回了')
    },
    openListen () {
      this.listenVisible = true
    },
    listenClose () {
      this.listenVisible = false
    },
    getLessonAduioList(materialId) {
      this.loading = true
      this.audioList = [];
      getLessonAduioList(materialId)
        .then((res) => {
          if (res.code === 0) {
            const audioList = res.data;
            if (res.data?.length > 0) {
              this.audio = res.data[0]
            }
            this.audioList = this.formatMaterialData(audioList);
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("服务器异常，听力材料加载失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatMaterialData(data) {
      let list = []
      if (data && data.length > 0) {
        data.forEach((item) => {
          list.push({
            id: item.id,
            title: item.name,
            src: item.audioUrl,
            cover: this.value.url
          })
        })
      }
      return list
    },
    // 播放
    handPlay () {
      this.isShowVoice = true
    },
    // 暂停
    handPause () {
      this.isShowVoice = false
    },
    // 下载音频
    handleDownAudio () {
      window.open(this.value.audioUrl)
    }
  }
}
</script>

<style lang="less" scoped>
#ua-container {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  overflow: auto;
  z-index: 999;
  background-color: #fff;
}
.orange-btn{
  margin-bottom: 20px;
}
// 修改新增等操作按钮默认颜色
.orange-btn{
  background-color: #FA7837;
  border-color: #FA7837;
  &:hover{
    background-color: #fa905b;
    border-color: #fa905b;
  }
}
.orange-btn:hover, .orange-btn:focus {
  background-color: #FA7837;
  border-color: #FA7837;
}
.card-box2 {
  border: none;
  position: relative;
  top: -30px;
  min-height: 57vh;
  border-left: none;
  border-right: none;
  border-bottom: none;
  border-radius: 20px 20px 0 0;
}

.header{
  width: 100%;
  padding: 10px 10px 50px;
  background-color: #09C0D7;
  box-sizing: border-box;
  color: #fff;
}
.main{
  position: relative;
  top: -30px;
  padding: 20px 10px 10px;
  background-color: #fff;
  border-radius: 20px;
}
.cover{
  width: 80px;
  height: 110px;
  margin-right: 20px;
}
.title{
  font-size: 14px;
  font-weight: bold;
}
.text{
  font-size: 13px;
}

.card-box2 .no-data {
  height: 40vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.titles{
  font-size: 22px;
  margin-bottom: 10px;
}
.left-title{
  line-height: 30px;
  font-weight: 600;
}
.pagination-box{
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 10px;
  .btn{
    height: 28px;
    text-align: center;
    line-height: 28px;
    background-color: #fff;
    border-color: #09C0D7;
    color: #09C0D7;
  }
}
/deep/ .player-box {
  .aplayer-list ol{
    overflow-y: visible !important;
    height: 100% !important;
  }
  .aplayer-list ol li{
    height: auto !important;
  }
  .aplayer-list-title {
    letter-spacing: 1px;
  }
}
/deep/.ant-card-body{
  padding: 15px !important;
}
</style>